import { render } from "./SudaniOption.vue?vue&type=template&id=15657608"
import script from "./SudaniOption.vue?vue&type=script&lang=js"
export * from "./SudaniOption.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__